export const BUSINESS_CASE_SIGNAL_FOCUS_TIERS = [
  ['customerAwaitingReply'],
  ['depositUnpaid', 'invoiceUnpaid'],
  ['closeBlocked', 'overdueTask'],
  ['offerExpired', 'expectedPurchaseDatePassed'],
  ['offerExpiringSoon', 'testDriveCompletedNoFollowUp', 'offerOpenedNoReply'],
  ['offerSentNoResponse', 'offerNotSent', 'expectedPriceAboveMax'],
  ['goingCold'],
  ['testDrivePlannedSoon'],
  ['engagement', 'missingNextStep'],
] as const;
